import React, { useState } from 'react';
import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';
import showNotification from '@shared/helpers/notifications';
import DepositsVerificationState from './DepositsVerificationState';
import Intro from './VerificationWizard/Intro';
import SelectWalletType from './VerificationWizard/SelectWalletType';
import SelectVASP from './VerificationWizard/SelectVASP';
import Completed from './VerificationWizard/Completed';
import SelectOwnerType from './VerificationWizard/SelectOwnerType';
import NaturalPersonForm from './VerificationWizard/NaturalPersonForm';
import LegalEntityForm from './VerificationWizard/LegalEntityForm';
import { OWNER_TYPE, WALLET_TYPE } from './model';
import { sendOwnership } from './service';
var VERIFICATION_STEPS;
(function (VERIFICATION_STEPS) {
    VERIFICATION_STEPS[VERIFICATION_STEPS["INTRO"] = 0] = "INTRO";
    VERIFICATION_STEPS[VERIFICATION_STEPS["WALLET_TYPE"] = 1] = "WALLET_TYPE";
    VERIFICATION_STEPS[VERIFICATION_STEPS["SELECT_VASP"] = 2] = "SELECT_VASP";
    VERIFICATION_STEPS[VERIFICATION_STEPS["SELECT_OWNER_TYPE"] = 3] = "SELECT_OWNER_TYPE";
    VERIFICATION_STEPS[VERIFICATION_STEPS["LEGAL_FORM"] = 4] = "LEGAL_FORM";
    VERIFICATION_STEPS[VERIFICATION_STEPS["NATURAL_FORM"] = 5] = "NATURAL_FORM";
    VERIFICATION_STEPS[VERIFICATION_STEPS["COMPLETED"] = 6] = "COMPLETED";
})(VERIFICATION_STEPS || (VERIFICATION_STEPS = {}));
const DepositsVerification = (props) => {
    const store = DepositsVerificationState({});
    const [loading, setLoading] = useState(false);
    const handleStepUpdate = (step) => {
        store.dispatch({ type: 'UPDATE_STEP', payload: { step } });
    };
    const handleSelectWallet = (type) => {
        store.dispatch({ type: 'SET_WALLET_TYPE', payload: { walletType: type } });
    };
    const handleSelectPersonType = (type) => {
        store.dispatch({ type: 'SET_PERSON_TYPE', payload: { ownerType: type } });
    };
    const handleOwnerTypeSelect = () => {
        switch (store.state.ownerType) {
            case OWNER_TYPE.SELF_OWNED:
                handleSubmit({});
                break;
            case OWNER_TYPE.LEGAL_ENTITY:
                handleStepUpdate(VERIFICATION_STEPS.LEGAL_FORM);
                break;
            case OWNER_TYPE.NATURAL_PERSON:
                handleStepUpdate(VERIFICATION_STEPS.NATURAL_FORM);
        }
    };
    const handleSubmit = (data) => {
        const params = Object.assign(Object.assign({}, data), { owner_type: store.state.ownerType, wallet_type: store.state.walletType, natural_person_date_of_birth: data.natural_person_date_of_birth
                ? dayjs(data.natural_person_date_of_birth).format('YYYY-MM-DD')
                : undefined });
        if (props.currentClient) {
            setLoading(true);
            sendOwnership(props.currentClient, props.item.code, params)
                .then(() => {
                handleStepUpdate(VERIFICATION_STEPS.COMPLETED);
                showNotification({ message: 'Ownwership verification was sent', color: 'success' });
            })
                .catch(() => {
                showNotification({ message: 'Ownwership verification failed', color: 'error' });
            })
                .finally(() => {
                setLoading(false);
            });
        }
    };
    const renderComponent = () => {
        switch (store.state.step) {
            case VERIFICATION_STEPS.INTRO:
                return (React.createElement(Intro, { deposit: props.item, onNext: () => handleStepUpdate(VERIFICATION_STEPS.WALLET_TYPE), onClose: props.toggle }));
            case VERIFICATION_STEPS.WALLET_TYPE:
                return (React.createElement(SelectWalletType, { onNext: () => handleStepUpdate(store.state.walletType === WALLET_TYPE.VASP_HOSTED
                        ? VERIFICATION_STEPS.SELECT_VASP
                        : VERIFICATION_STEPS.SELECT_OWNER_TYPE), onClose: props.toggle, onWalletTypeChange: handleSelectWallet }));
            case VERIFICATION_STEPS.SELECT_VASP:
                return (React.createElement(SelectVASP, { onBack: () => handleStepUpdate(VERIFICATION_STEPS.WALLET_TYPE), onNext: (data) => {
                        handleSubmit(data);
                    }, loading: loading }));
            case VERIFICATION_STEPS.SELECT_OWNER_TYPE:
                return (React.createElement(SelectOwnerType, { loading: loading, deposit: props.item, client: props.client, onNext: () => handleOwnerTypeSelect(), onBack: () => handleStepUpdate(VERIFICATION_STEPS.WALLET_TYPE), onWallerOwnerChange: handleSelectPersonType }));
            case VERIFICATION_STEPS.NATURAL_FORM:
                return (React.createElement(NaturalPersonForm, { loading: loading, onBack: () => handleStepUpdate(VERIFICATION_STEPS.SELECT_OWNER_TYPE), onNext: (data) => {
                        handleSubmit(data);
                    } }));
            case VERIFICATION_STEPS.LEGAL_FORM:
                return (React.createElement(LegalEntityForm, { loading: loading, onBack: () => handleStepUpdate(VERIFICATION_STEPS.SELECT_OWNER_TYPE), onNext: (data) => {
                        handleSubmit(data);
                    } }));
            case VERIFICATION_STEPS.COMPLETED:
                return (React.createElement(Completed, { onClose: () => {
                        props.toggle();
                        props.fetchDeposits(props.urlDeposits);
                    } }));
        }
    };
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
        React.createElement(Box, null,
            React.createElement(Typography, { variant: 'subtitle1', fontWeight: 'bold' }, "Originator Verification"),
            React.createElement(Typography, { variant: 'caption' }, "Complete the verification process for this deposit")),
        renderComponent()));
};
export default DepositsVerification;
